import { FC, SVGProps } from 'react';

const WarningIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 2.06262C12.831 2.06262 15.9375 5.16837 15.9375 9.00012C15.9375 12.8311 12.831 15.9376 9 15.9376C5.16825 15.9376 2.0625 12.8311 2.0625 9.00012C2.0625 5.16837 5.16825 2.06262 9 2.06262Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.99634 6.1532V9.46745"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.99609 11.8472H9.00484"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default WarningIcon;
